<div
  [ngClass]="{
    'left-1': _position === 'start',
    'justify-items-end': _position === 'end'
  }"
>
  <ng-content></ng-content>
</div>
